module.exports = __webpack_public_path__ + "assets/img/tab-cover3-439bf554.jpg";